import Navigation from "./components/header.js";
import {Homepage} from "./pages/homepage.js";
import {Programmes} from "./pages/programmes.js";
import {EventsDetail} from "./pages/eventsDetail.js";
import {Contact} from "./pages/contact.js";
import {OrderForm} from "./pages/orderForm.js";
import {SelfActivities} from "./pages/selfActivities.js";

let project;

export default class Project {
	constructor() {
		if(project) {
			return project;
		}
		project = this;

		this.DOM = {
			body: document.body
		}

		this.pageType = this.DOM.body.dataset.pageType ?? 'default';

		this.hooks = {
			resize: [],
			scroll: []
		}

		this.instances = {
			page: null,
			navigation: new Navigation()
		}

		this.init()
	}

	init() {
		this.initPage();
		this.handleEvents();
	}

	initPage() {
		switch (this.pageType) {
			case 'homepage':
				this.instances.page = new Homepage();
				return;
			case 'sezonniAkce':
				return;
			case 'sezonniAkceDetail':
				this.instances.page = new EventsDetail();
				return;
			case 'samoobsluzneAktivity':
				this.instances.page = new SelfActivities();
				return;
			case 'programy':
				this.instances.page = new Programmes();
				return;
			case 'programyDetail':
				return;
			case 'kontakt':
				this.instances.page = new Contact();
				return;
			case 'objednavkovyFormular':
				this.instances.page = new OrderForm();
				return;
			default:
		}
	}

	handleEvents() {
		window.addEventListener('resize', () => {
			this.hooks.resize.forEach((callback) => callback())
		})

		window.addEventListener('scroll', () => {
			this.hooks.scroll.forEach((callback) => callback())
		})
	}
}

window.project = new Project()